Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramStoryContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.InstagramStoryContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.group_type == 'instagramapi' and socialContent.data and socialContent.data.is_story and socialContent.data.type == 'instagramMedia'
